import axios from "axios";
import { logout } from "../services/authService";

let interceptorAttached = false;

export const setResInterceptor = () => {
  if (interceptorAttached) return; 
  interceptorAttached = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        logout();
      }
      return Promise.reject(error);
    }
  );
};
